<template>
  <div class="container pt-lg-md" style="display: flex; justify-content: center; color: #000;">
    <div class="row justify-content-center col-lg-5">
      <card
        type="secondary"
        shadow
        header-classes="bg-white pb-5"
        body-classes="px-lg-5 py-lg-5"
        class="border-0"
        style="width: 100%;"
      >
        <template>
          <div class="text-center text-muted mb-4">
            <small>Бүртгэлийн мэдээллээ оруулна уу</small>
          </div>
          <form role="form">
            <!-- Овог -->
            <div class="text-danger">{{ errors.firstname }}</div>
            <base-input
              alternative
              class="mb-3"
              placeholder="Нэр"
              addon-left-icon="ni ni-hat-3"
              v-model="formData.firstname"
              @input="validateField('firstname')"
            ></base-input>
            
            <!-- Нэр -->
            <div class="text-danger">{{ errors.lastname }}</div>
            <base-input
              alternative
              class="mb-3"
              placeholder="Овог"
              addon-left-icon="ni ni-hat-3"
              v-model="formData.lastname"
              @input="validateField('lastname')"
            ></base-input>
            
            <!-- Имэйл -->
            <div class="text-danger">{{ errors.email }}</div>
            <base-input
              alternative
              class="mb-3"
              placeholder="Имэйл"
              addon-left-icon="ni ni-email-83"
              v-model="formData.email"
              @input="validateField('email')"
            ></base-input>
            
            <!-- Утасны дугаар -->
            <div class="text-danger">{{ errors.phone }}</div>
            <base-input
              alternative
              class="mb-3"
              placeholder="Утасны дугаар"
              addon-left-icon="ni ni-mobile-button"
              v-model="formData.phone"
              @input="validateField('phone')"
            ></base-input>
            
            <!-- Нууц үг -->
            <div class="text-danger">{{ errors.password }}</div>
            <base-input
              alternative
              type="password"
              placeholder="Нууц үг"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="formData.password"
              @input="validateField('password')"
            ></base-input>
            
            <!-- Нууц үгээ баталгаажуулах -->
            <div class="text-danger">{{ errors.confirmPassword }}</div>
            <base-input
              alternative
              type="password"
              placeholder="Нууц үгээ баталгаажуулах"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="formData.confirmPassword"
              @input="validateField('confirmPassword')"
            ></base-input>

            <!-- Нууц үгийн хүч чадал -->
            <div class="text-muted font-italic">
              <small>нууц үгийн сонголт: 
                <span class="text-success font-weight-700">Хүчтэй</span>
              </small>
            </div>

            <!-- Нууцлалын бодлого зөвшөөрөх -->
            <base-checkbox v-model="formData.privacyPolicy">
              <span>
                Би 
                <router-link :to="{ name: 'terms' }" target="_blank" rel="noopener">
                  Үйлчилгээний нөхцөл
                </router-link>
                болон 
                <router-link :to="{ name: 'policy' }" target="_blank" rel="noopener">
                  Нууцлалын бодлого
                </router-link>
                санал нийлж байна
              </span>
            </base-checkbox>
            <div class="text-danger" v-if="!formData.privacyPolicy">
              Нууцлалын бодлогыг зөвшөөрнө үү
            </div>

            <!-- Бүртгэл үүсгэх товч -->
            <div class="text-center">
              <base-button
                type="primary"
                class="my-4"
                :disabled="isLoading"
                @click="register"
              >
                {{ isLoading ? "Ачааллаж байна..." : "Бүртгэл үүсгэх" }}
              </base-button>
            </div>
          </form>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

export default defineComponent({
  name: "Registration",
  data() {
    return {
      isLoading: false,
      formData: {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        username: "",
        password: "",
        confirmPassword: "",
        privacyPolicy: false,
      },
      errors: {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
      },
    };
  },
  methods: {
    validateField(field) {
      this.errors[field] = "";
      const value = this.formData[field];

      switch (field) {
        case "firstname":
        case "lastname":
          if (!value) {
            this.errors[field] = "Энэ талбар шаардлагатай";
          } else if (value.length < 2) {
            this.errors[field] = "Хамгийн багадаа 2 тэмдэгт оруулна уу";
          }
          break;

        case "email":
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
          if (!value) {
            this.errors.email = "Имэйл хаягаа оруулна уу";
          } else if (!emailRegex.test(value)) {
            this.errors.email = "Буруу имэйл хаяг";
          }
          break;

        case "phone":
          const phoneRegex = /^[0-9]{8}$/;
          if (!value) {
            this.errors.phone = "Утасны дугаар шаардлагатай";
          } else if (!phoneRegex.test(value)) {
            this.errors.phone = "8 оронтой байх ёстой";
          }
          break;

        case "password":
          if (!value) {
            this.errors.password = "Нууц үг шаардлагатай";
          } else if (value.length < 8) {
            this.errors.password = "Хамгийн багадаа 8 тэмдэгт байх ёстой";
          } else if (!/[A-Z]/.test(value)) {
            this.errors.password = "Нууц үг дор хаяж нэг том үсэг агуулсан байх ёстой";
          } else if (!/[0-9]/.test(value)) {
            this.errors.password = "Нууц үг дор хаяж нэг тоо агуулсан байх ёстой";
          }
          break;

        case "confirmPassword":
          if (!value) {
            this.errors.confirmPassword = "Нууц үгээ баталгаажуулна уу";
          } else if (value !== this.formData.password) {
            this.errors.confirmPassword = "Нууц үг таарахгүй байна";
          }
          break;
      }
    },
    async register() {
      if (this.isLoading) return;

      // Validate all fields except privacyPolicy
      const isValid = Object.keys(this.formData).every((field) => {
        if (field !== "privacyPolicy") {
          this.validateField(field);
        }
        return !this.errors[field];
      });

      if (!this.formData.privacyPolicy) {
        this.$alert.showAlert("Та нууцлалын бодлогыг зөвшөөрөх ёстой", "success");
        return;
      }

      if (isValid) {
        this.isLoading = true;
        try {
          const response = await axios.post("/register", this.formData);
          console.log("Бүртгэл амжилттай:", response.data);
          this.$alert.showAlert("Бүртгэл амжилттай!", "success");
          this.$router.push("/");
        } catch (error) {
          console.error("Бүртгэлийн алдаа:", error);
          this.$alert.showAlert("Алдаа гарлаа. Дахин оролдоно уу.", "error");
        } finally {
          this.isLoading = false;
        }
      }
    },
  },
});
</script>

<style>
.text-danger {
  color: #e3342f;
  font-size: 0.85rem;
}
</style>
